import { render } from "./OrderDetails.vue?vue&type=template&id=8cc3e10a&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=8cc3e10a&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cc3e10a"]])

export default __exports__